import { RECEIVE_ORDER_INFORMATION } from 'constants/reduxActions';

import { sendMonetateEvent } from 'apis/monetate';
import { productBundle } from 'apis/cloudcatalog';
import { CHECKOUT_RECEIVE_ORDER_INFORMATION } from 'store/ducks/checkout/types';
import { call } from 'redux-saga/effects';
import { isAssigned } from 'actions/ab';
import marketplace from 'cfg/marketplace.json';

const { checkout: { melodyHydraTest } } = marketplace;
const ORDER_CONFIRMATION_PAGEVIEW = 'ORDER_CONFIRMATION_PAGEVIEW';

const melodyCheckoutActive = state => isAssigned(melodyHydraTest, 2, state);

function* monetateOcView(appState) {
  const purchasedItems = [];
  const orders = appState?.checkoutData?.purchaseData?.orderInfo || appState?.melodyCheckoutData?.orderInfo || [];

  const { environmentConfig: { api: { cloudcatalog } } } = appState;

  for (const order of orders) {
    for (const item of order.items) {
      const { productId, itemQuantity: quantity, price } = item;
      const productPromise = yield call(productBundle, cloudcatalog, { productId, includeOos: true });
      const productResponse = yield productPromise.json();
      const product = productResponse.product[0] || null;
      if (product && product.styles.length > 0) {
        const style = productResponse.product[0].styles.filter(s => s.color === item.color);
        if (style?.[0]) {
          const { styleId } = style[0];
          purchasedItems.push({ purchaseId: order.orderId, sku: styleId, productId, quantity, unitPrice: price });
        }
      }
    }
  }

  sendMonetateEvent(
    ['setPageType', 'confirmation'],
    ['addPurchaseRows', purchasedItems]
  );
}

export default state => {
  const isMelodyCheckout = melodyCheckoutActive(state);
  return {
    clientCalled: isMelodyCheckout ? CHECKOUT_RECEIVE_ORDER_INFORMATION : RECEIVE_ORDER_INFORMATION,
    pageEvent: ORDER_CONFIRMATION_PAGEVIEW,
    hasRedirects: true,
    events: {
      [ORDER_CONFIRMATION_PAGEVIEW]: [monetateOcView]
    }
  };
};
